module.exports = __webpack_public_path__ + "img/20.dc216006.jpg";